import api from "@/lib/api";

export async function fetchStories(params = {}) {
  const { data } = await api.get("/stories", { params });
  return data;
}

export async function fetchStoryFilters() {
  const { data } = await api.get("/stories/filters");
  return data;
}

export async function fetchStoryBySlug(slug) {
  const { data } = await api.get(`/stories/${slug}`);
  return data;
}

export async function adminListStories(params = {}) {
  const { data } = await api.get("/admin/stories", { params });
  return data;
}

export async function adminGetStory(id) {
  const { data } = await api.get(`/admin/stories/${id}`);
  return data;
}

export async function adminCreateStory(payload) {
  const { data } = await api.post("/admin/stories", payload);
  return data;
}

export async function adminUpdateStory(id, payload) {
  const { data } = await api.put(`/admin/stories/${id}`, payload);
  return data;
}

export async function adminTogglePublish(id) {
  const { data } = await api.patch(`/admin/stories/${id}/publish`);
  return data;
}

export async function adminDeleteStory(id) {
  await api.delete(`/admin/stories/${id}`);
}
